import { render } from "./LandingPages.vue?vue&type=template&id=56208b9e"
import script from "./LandingPages.vue?vue&type=script&lang=js"
export * from "./LandingPages.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__